import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { BookingTermsAndPolicy, ControlButtons } from 'components/elements';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function FormWrapper({ children, navigation, parentClassName }) {
  const classes = useStyles();
  const [allowSubmit, setAllowSubmit] = useState(false);
  return (
    <>
      <div className={parentClassName ? cn(classes.formWrapper, parentClassName) : classes.formWrapper}>
        {children}
        {!navigation.props.isLastStep && navigation}
      </div>
      {navigation.props.isLastStep && (
        <div className={parentClassName}>
          <BookingTermsAndPolicy onTermsAccepted={(termsAccepted) => setAllowSubmit(termsAccepted)} />
          <Box className={classes.controlButtons}>
            <ControlButtons
              formId={navigation.props.formId}
              onClickNext={navigation.props.onClickNext}
              onClickBack={navigation.props.onClickBack}
              isLastStep
              isFirstStep={false}
              canClickBack
              canClickNext={!navigation.props.processing && allowSubmit}
            />
          </Box>
        </div>
      )}
    </>
  );
}

FormWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  navigation: PropTypes.element.isRequired,
  parentClassName: PropTypes.any.isRequired,
};

export default FormWrapper;
